import {
  IUpdateExerciseTagCommand,
  PaginatedListOfExerciseTagDto,
} from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../../hooks/useOptimisticUpdateMutation";
import { COACH_EXERCISE_TAGS_LIST_QUERY_KEY } from "../../../../routes/coach/library/exercise-library/list/CoachExerciseTagsListRoute";
import ExerciseTagsService from "../../../../services/ExerciseTagsService";
import { useQueryClient } from "@tanstack/react-query";
import { INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE } from "./useCreateExerciseTag";
import { tagOnSuccessHandler } from "../../../coach-clients-tags/mutations/useCreateClientTag";

export function useUpdateExerciseTag() {
  const queryClient = useQueryClient();
  return useOptimisticUpdateMutation({
    queryKey: [COACH_EXERCISE_TAGS_LIST_QUERY_KEY],
    mutationFn: ExerciseTagsService.updateExerciseTag,
    successToastMessage: "Update exercise tag",
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfExerciseTagDto,
        variables: IUpdateExerciseTagCommand,
      ) => {
        const updatedItems = oldData.items.map((item) =>
          item.id === variables.id ? { ...item, ...variables } : item,
        );

        return {
          ...oldData,
          items: updatedItems,
        } as PaginatedListOfExerciseTagDto;
      },
    },
    options: {
      onSuccess: () => {
        tagOnSuccessHandler(
          queryClient,
          INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE,
        );
      },
    },
  });
}
